export const VariationIds = {
  Cpc_AB_Test: "201",
  ExpandedDescription_AB_Test: "202",
  Quantity_Discount_AB_Test: "203",
  HomePage_Personalization_AB_Test: "205",
  SearchEssence_AB_Test: "404",
};
